import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

// Attach optional Bearer token stored in localStorage (fallback for envs where 3rd-party cookies are blocked)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('uncloned_admin_token');
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (!detail) return err?.message || 'Something went wrong';
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' ');
    return String(detail);
}

// Resolve backend file URL (works for both remote /api/files/... and absolute urls)
export function fileUrl(pathOrUrl) {
    if (!pathOrUrl) return '';
    if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
    if (pathOrUrl.startsWith('/api/')) return `${BACKEND_URL}${pathOrUrl}`;
    return pathOrUrl;
}
